export default __webpack_public_path__ + "static/media/img-new-home-4-video.f4f3752b.jpg";